import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Helmet } from "react-helmet";

const Contact = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.hbspt.forms.create({
                portalId: '7585485',
                formId: 'b472ef23-d7aa-4909-83a9-e8f71e0f26f9',
                target: '#hubspot-form-container',
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
           <Helmet prioritizeSeoTags={true}>
  <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
  <meta name="format-detection" content="telephone=no" />
  <title>Codezix Contact Us | Contact Codezix LLP</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <meta
    name="description"
    content="Get in touch with Codezix LLP for Salesforce consulting, implementation, and support services. Contact our experts to discuss your Salesforce and cloud requirements."
  />
  <meta
    name="keywords"
    content="Codezix contact, contact Codezix LLP, Salesforce consulting contact, Salesforce support contact, get in touch Codezix"
  />

  {/* BreadcrumbList */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Contact Us",
      "item": "https://codezix.com/contact"
    }
  ]
}
    `}
  </script>

  {/* ContactPage */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "@id": "https://codezix.com/contact#contactpage",
  "url": "https://codezix.com/contact",
  "name": "Contact Codezix LLP",
  "description": "Reach out to Codezix LLP for Salesforce consulting, implementation, and support services.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  },
  "about": {
    "@id": "https://codezix.com/#organization"
  }
}
    `}
  </script>

  {/* Organization */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce, cloud consulting, and custom application development company helping organizations innovate faster.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+1-917-730-7436",
      "contactType": "customer support",
      "availableLanguage": [
        "English",
        "Hindi"
      ],
      "areaServed": [
        "US",
        "AU",
        "IN"
      ]
    }
  ]
}
    `}
  </script>

  {/* WebSite */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
    `}
  </script>
</Helmet>




            <div className='contact-section padding_top_contact bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <div className='contact-left top'>
                                <div className='contact_left_first'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/fast.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>Quick response</strong></span>
                                        <p className='prose-lg'>We usually respond within an hour during business hours to sign the NDA and arrange a discussion.</p>
                                    </div>
                                </div>
                                <div className='contact_left_first mt-4'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/personalization.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>Personalized approach</strong></span>
                                        <p className='prose-lg'>You will collaborate directly with specialists who have expertise in your specific field.</p>
                                    </div>
                                </div>
                                <div className='contact_left_first mt-4'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/no-pressure.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>No pressure</strong></span>
                                        <p className='prose-lg'>We’re here to understand your needs and provide guidance — whenever you’re ready to move forward.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7 contact_margin'>
                            <div className='contact_form_middle'>
                                <div className='contact_about'>
                                    <h3>Let's discuss your needs!</h3>
                                    <p className='prose-md'>Got a question for our specialists, want to discuss your project, or learn more about our expertise? Just submit your request using the form below!</p>
                                </div>
                                <div className='contact_form'>
                                    <div id="hubspot-form-container" style={{ minHeight: "600px", overflow: "hidden" }}></div>

                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 contact-right-bg'>
                            <div className='contact_right'>
                                <span><strong>Our Contacts</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="tel:+61290995838">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+61-(290) 995838 </span>
                                        </Link>
                                    </div>
                                    <div className='call_1'>
                                        <Link to="tel:+19177307436">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+1-(917) 7307436</span>
                                        </Link>
                                    </div>
                                    <div className='call_1'>
                                        <Link to="tel:+442037697122">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+44-(203) 7697122</span>
                                        </Link>
                                    </div>
                                    <div className='call_2 mt-4'>
                                        <Link to="mailto:info@codezix.com">
                                            <img src={require('../assets/images/mail-us.webp')} alt="" />
                                            &nbsp;info@codezix.com
                                        </Link>
                                    </div>
                                    <div className='call_3 mt-4'>
                                        <Link to="https://wa.me/13477462125" target="_blank">
                                            <img src={require('../assets/images/whtsp.webp')} alt="" />
                                            &nbsp;+91-(888) 2313131
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='contact_right'>
                                <span><strong>Our Blogs</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="https://www.winklix.com/blog/" target='_blank'>
                                            <img src={require('../assets/images/voice.webp')} alt="" />
                                            &nbsp;<span>Read our blog</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='contact_right'>
                                <span><strong>Join our team</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="/career">
                                            <img src={require('../assets/images/messenger-cv.webp')} alt="" />
                                            &nbsp;<span>Upload your CV</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className='contact_right'>
                                <span><strong>Social media</strong></span>
                                <div className='contact-social'>
                                    <div className='social_midea'>
                                        <Link to="https://www.linkedin.com/company/codezix/" target="_blank"><img src={require('../assets/images/linkedin.webp')} alt='' /></Link>
                                        <Link to="https://www.youtube.com/channel/UCS9W-DHO95H39gavX8ICcdA" target="_blank"><img src={require('../assets/images/youtube.webp')} alt='' /></Link>
                                        <Link to="https://x.com/winklix?mx=2" target="_blank"><img src={require('../assets/images/twitter.webp')} alt='' /></Link>
                                        <Link to="https://www.facebook.com/Winklix/" target="_blank"><img src={require('../assets/images/facebook.webp')} alt='' /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='client-says top'>
                <div className='container'>
                    <h2 className='heading1 text-center'>Enduring Relationships</h2>
                    <div className='row'>
                        <Swiper
                            breakpoints={{
                                300: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                425: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 30,
                                },
                                1440: {
                                    slidesPerView: 5,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-6.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-7.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-8.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-9.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-10.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='relationship-user'>
                                    <img src={require('../assets/images/client/part-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='client-section'>
                <div className='container'>
                    <h2 className='heading1 text-center'>Our Technology Partnerships</h2>
                    <p className='prose-lg'>Throughout our history, Codezix has built strong partnerships with leading technology companies, who have consistently recognized our technical expertise and our ability to understand and address our clients' needs, all while delivering high-quality services.</p>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                425: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 20,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-6.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-7.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-8.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/footer/partner-9.webp')} alt='' />
                                </div>
                            </SwiperSlide>

                        </Swiper>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Contact;